// extracted by mini-css-extract-plugin
export var alertIcon = "_p0-0";